import { NotificationConfiguration } from '../notification.templates';

export const RACI_REPORT_SHARED: NotificationConfiguration = {
  inapp: `<b>{triggeredByName}</b> shared a report with you.`,
  email: {
    ctaKey: 'go_to_report',
  },
};
